<template>
  <v-app class="page">
    <v-app-bar
      class="header"
      app
      fixed
      dense
      elevation="0"
      color="primary"
      dark
    >
      <v-toolbar-title>
        <v-btn text class="mr-5" v-on:click="goBack">
          <v-icon left>fas fa-arrow-left</v-icon>
          Back
        </v-btn>
        <b>Detail Sales</b>
        <v-btn
          text
          :elevation="0"
          class="mr-5 float-right"
          v-on:click="exportPDF"
          data-url="http://localhost:9002/uploads/pdfs/5SEH8FliohqN8fi_1668120870980.pdf"
        >
          <v-icon left>fas fa-file-pdf</v-icon>
          Export PDF
        </v-btn>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-main>
      <v-container fluid class="fill-height" id="qr-template">
        <v-card
          id="qr-template"
          width="100%"
          elevation="15"
          class="full-height ml-2 mr-2 fill-width fill-height"
          :loading="status === 'loading'"
        >
          <v-card-text>
            <div id="content-purchase-summary">
              <div id="purchase_summary">
                <div class="flex-col-6">
                  <div class="flex-row generic-black-text">
                    <div class="flex-col" v-if="payment.order_id !== null">
                      <h5 class="text-title co-text-center padd-0 marg-0">
                        Purchase Summary
                      </h5>
                      <div class="flex-col padd-0 marg-0">
                        <div class="flex-row flex-content-between ">
                          <div class="flex-col end ">
                            <img
                              :src="images_general.logo"
                              width="100"
                            />
                          </div>
                          <div class="flex-col text-sales-align-right">
                            <img
                              v-if="
                                payment.order_id &&
                                  payment.order_id.store &&
                                  payment.order_id.store.picture
                              "
                              :src="payment.order_id.store.picture"
                              width="100"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        class="flex-col padd-0 marg-0"
                        v-if="payment.order_id.store !== null"
                      >
                        <div>
                          <h6 class="text-subtitle padd-0 marg-0">
                            {{ payment.order_id.store.name }}
                          </h6>
                        </div>
                        <div class="list-sales padd-0 marg-0">
                          <svg
                            viewBox="0 0 585.1428571428571 1024"
                            class="home-icon"
                          >
                            <path
                              d="M438.857 365.714c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM585.143 365.714c0 34.857-4 70.857-18.857 102.286l-208 442.286c-12 25.143-38.286 40.571-65.714 40.571s-53.714-15.429-65.143-40.571l-208.571-442.286c-14.857-31.429-18.857-67.429-18.857-102.286 0-161.714 130.857-292.571 292.571-292.571s292.571 130.857 292.571 292.571z"
                            ></path>
                          </svg>
                          <span class="text-grey text-location">{{
                            payment.order_id.store.address
                          }}</span>
                          <span class="text-grey text-location d-block mt-2">{{
                              payment.order_id.date_timezone?formatDate(payment.order_id.date_timezone):formatDate(payment.order_id.createdAt)
                          }}</span>
                        </div>
                      </div>
                      <div
                        class="flex-col"
                        v-if="payment.order_id.items.length > 0"
                      >
                        <h4 class="text-subtitle space-bottom">
                          Quantity of products:
                          {{ payment.order_id.items.length }}
                        </h4>
                        <h4 class="text-subtitle space-bottom">Product List</h4>
                        <div
                          class="flex-row sales-align-center all-padding-item"
                          v-for="(item, index) in payment.order_id.items"
                          :key="'product_' + index"
                        >
                          <div class="flex-col-image">
                            <img
                              style="max-width: 45px;max-height: 45px;position: relative;object-fit: contain;"
                              v-if="item.product.picture"
                              class="card-img img-data"
                              :src="item.product.picture"
                              alt="Image Description"
                            />
                          </div>
                          <div class="flex-col-content">
                            <div>

                              <span>{{ item.product.name }}</span>
                              <p class="text-green mb-0" v-if="item.redeemed_coupon">COUPON APPLIED
                                {{ item.redeemed_coupon.coupon && item.redeemed_coupon.coupon.discount?item.redeemed_coupon.coupon.discount+'%':'' }}</p>
                              <div class="list-sales">
                                <p class="text-prices mb-0" v-if="item.price">
                                  {{ item.price }}
                                </p>
                                <div v-if="item.product.sku">
                                  <span> Sku or Item Number </span>
                                  <p class="">
                                    {{item.product.sku}}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!--    {{ payment.order_id }} -->
                        <div class="flex-row space-bottom">
                          <div class="flex-col">
                            <h4
                              class="text-subtitle space-bottom"
                              style="margin-top: -5px"
                            >
                              Payment Method:
                            </h4>
                          </div>
                          <div class="flex-col text-sales-align-right">
                            <img
                              v-if="
                                payment.order_id.payment_method_brand === 'amex'
                              "
                              style="width:50px"
                              :src="images_card.ic_american_express"
                              alt=""
                            />
                            <img
                              v-if="
                                payment.order_id.payment_method_brand ===
                                  'discovery'
                              "
                              style="width:50px"
                              :src="images_card.ic_discover"
                              alt=""
                            />
                            <img
                              v-if="
                                payment.order_id.payment_method_brand ===
                                  'mastercard'
                              "
                              style="width:50px"
                              :src="images_card.ic_master_card"
                              alt=""
                            />
                            <img
                              v-if="
                                payment.order_id.payment_method_brand === 'visa'
                              "
                              style="width:50px"
                              :src="images_card.ic_visa"
                              alt=""
                            />
                            <img
                              v-if="
                                payment.order_id.payment_method_brand !==
                                  'amex' &&
                                  payment.order_id.payment_method_brand !==
                                    'discovery' &&
                                  payment.order_id.payment_method_brand !==
                                    'mastercard' &&
                                  payment.order_id.payment_method_brand !==
                                    'visa'
                              "
                              style="width:50px"
                              :src="images_card.ic_stripe"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="flex-row space-bottom">
                          <div class="flex-col">
                            <h4
                              class="text-subtitle space-bottom"
                              style="margin-top: -5px"
                            >
                              Payment Method Last 4:
                            </h4>
                          </div>
                          <div
                            class="flex-col text-sales-align-right"
                            v-if="payment.order_id.payment_method_last4"
                          >
                            {{
                              payment.order_id.payment_method_last4
                                ? payment.order_id.payment_method_last4
                                : ""
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="all-padding-item">
                        <p class="text-subtitle">Total</p>
                        <div class="flex-row space-bottom">
                          <div class="flex-col text-grey">Subtotal:</div>
                          <div
                            class="flex-col text-sales-align-right text-totals"
                          >
                            ${{
                              parseFloat(
                                payment.order_id.sub_total || 0
                              ).toFixed(2)
                            }}
                          </div>
                        </div>
                        <div class="flex-row space-bottom">
                          <div class="flex-col text-grey">Total Discount:</div>
                          <div
                            class="flex-col text-sales-align-right text-totals"
                          >
                            -${{
                              payment.order_id.discount == 0
                                ? (0).toFixed(2)
                                : parseFloat(
                                    payment.order_id.discount || 0
                                  ).toFixed(2)
                            }}
                          </div>
                        </div>
                        <div class="flex-row space-bottom">
                          <div class="flex-col text-grey">Instalane Fee:</div>
                          <div
                            class="flex-col text-sales-align-right text-totals"
                          >
                            ${{ (199 / 100).toFixed(2) }}
                          </div>
                        </div>
                        <div class="flex-row space-bottom">
                          <div class="flex-col text-grey">Taxes:</div>
                          <div
                            class="flex-col text-sales-align-right text-totals"
                          >
                            ${{ parseFloat(payment.order_id.taxes || 0).toFixed(2) }}
                          </div>
                        </div>
                        <div class="flex-row space-bottom">
                          <div class="flex-col text-grey">Total:</div>
                          <div
                            class="flex-col text-sales-align-right text-total"
                          >
                            ${{ (parseFloat(payment.amount) / 100).toFixed(2) }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="flex-row sales-align-center"
                        style="page-break-inside: avoid;"
                      >
                        <img :src="img_qr" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center" class="mb-6">
              <v-btn color="warning" elevation="0" class="mr-4" @click="goBack">
                Back
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapActions, mapState } from "vuex";
import { config } from "@/config/constants.js";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";
import axios from "axios";
import moment from "moment";
//Import Image
const ic_american_express = require("@/assets/img/icons_payment/ic_american_express.png");
const ic_discover = require("@/assets/img/icons_payment/ic_discover.png");
const ic_master_card = require("@/assets/img/icons_payment/ic_master_card.png");
const ic_visa = require("@/assets/img/icons_payment/ic_visa.png");
const ic_stripe = require("@/assets/img/icons_payment/ic_stripe.png");
const frame_logo = require('@/assets/Frame.svg')

/*function toDataURL(src, callback){
  var image = new Image();
  image.crossOrigin = 'Anonymous';
  image.onload = function(){
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    canvas.height = this.naturalHeight;
    canvas.width = this.naturalWidth;
    context.drawImage(this, 0, 0);
    var dataURL = canvas.toDataURL('image/jpeg');
    callback(dataURL);
  };
  image.src = src;
}
toDataURL(ic_american_express,  function(dataURL){ ic_american_express = dataURL})*/
export default {
  mixins: [CrudFormMixin],
  components: { ValidationProvider, ValidationObserver, CrudForm },
  computed: {
    ...mapState({
      status: state => state.Sales.status
    })
  },
  async created() {
    const self = this;
    let payment = await this.$store.dispatch("Sales/get_payment", {
      payment_id: this.$route.params.id
    });
    console.log("payment");
    console.log(payment);
    this.payment = payment;

    // QR
    const QRCode = require("qrcode");
    // Creating the data
    let data = payment.order_id.id;

    // Converting the data into String format
//    let stringdata = JSON.stringify(data);

    let qr = "";
    // Converting the data into base64
    QRCode.toDataURL(data, function(err, code) {
      if (err) return console.log("error occurred dsds");

      // Printing the code
      console.log("code");
      qr = code;
      console.log(qr);
    });
    this.img_qr = qr;

    this.toDataURL(ic_american_express, dataURL => {
      self.images_card.ic_american_express = dataURL;
    });
    this.toDataURL(ic_discover, dataURL => {
      self.images_card.ic_discover = dataURL;
    });
    this.toDataURL(ic_master_card, dataURL => {
      self.images_card.ic_master_card = dataURL;
    });
    this.toDataURL(ic_visa, dataURL => {
      self.images_card.ic_visa = dataURL;
    });
    this.toDataURL(ic_stripe, dataURL => {
      self.images_card.ic_stripe = dataURL;
    });
    this.toDataURL(frame_logo, dataURL => {
      self.images_general.logo = dataURL;
    });
  },
  data: () => ({
    storeName: "Sales",
    parentStoreName: "Sales",
    title: "Sales",
    images_general:{
      logo:frame_logo
    },
    img_qr: "",
    images_card: {
      ic_american_express: ic_american_express,
      ic_discover: ic_discover,
      ic_master_card: ic_master_card,
      ic_visa: ic_visa,
      ic_stripe: ic_stripe
    },
    payment: {
      payment_intent_id: "",
      amount: null,
      pay_status: "",
      data: {},
      order_id: {
        sub_total: 0,
        discount: "",
        fee: null,
        payment_method_brand: "amex",
        taxes: null,
        items: [],
        notes: [],
        createdAt: "",
        updatedAt: "",
        id: "",
        store: {},
        guard: null,
        total: null
      },
      client_id: {
        fullname: "",
        email: "",
        id: "",
        access_token: "",
        profile_picture: ""
      },
      createdAt: "",
      updatedAt: "",
      id: "",
      created_at: "",
      updated_at: ""
    }
  }),
  methods: {
    ...mapActions({
      getPdfOfHtml: "External_api/convertHtmlToPdf"
    }),
    buildRootUrl() {
      return "/admin/" + "Sales".toLowerCase();
    },
    goBack() {
      this.$router.push(this.buildRootUrl());
    },
    roundNumber(value, percentage, round) {
      return Number((value * percentage).toFixed(round));
    },
    async exportPDF() {
      const self = this;
      let html_purchase = $(`#content-purchase-summary`).html();
      let pdf = await this.getPdfOfHtml(
        `${this.style_purchase()} <body> ${html_purchase}</body> `
      );
      if (pdf) {
        setTimeout(() => {
          let array_path = pdf.file.split("/");
          self.download(pdf.file, "purchase_sumary.pdf");
        }, 500);
      }
    },
    download(url, filename) {
      fetch(url)
        .then(response => response.blob())
        .then(blob => {
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        })
        .catch(console.error);
    },
    style_purchase: () => {
      let styles = $("#sales-purchase")
        .last()
        .html();
      return `<head><meta charset="utf8"/>
        <style>
         ${styles}
         .text-green{
            color: #13b156 !important;
         }
         .d-block{
            display: block;
          }
          .mt-2 {
            margin-top: 8px!important;
          }
        </style>
        </head>`;
    },
    /*toDataURL(src, callback){
      var image = new Image();
      image.crossOrigin = 'Anonymous';
      image.onload = function(){
        var canvas = document.createElement('canvas');
        canvas.style.backgroundColor = 'white'
        var context = canvas.getContext('2d');
        context.drawImage(this, 0, 0);
        var dataURL = canvas.toDataURL('image/jpeg');
        callback(dataURL);
      };
      image.src = src;
    },*/
    toDataURL(url, callback) {
      let xhRequest = new XMLHttpRequest();
      xhRequest.onload = function() {
        let reader = new FileReader();
        reader.onloadend = function() {
          callback(reader.result);
        };
        reader.readAsDataURL(xhRequest.response);
      };
      xhRequest.open("GET", url);
      xhRequest.responseType = "blob";
      xhRequest.send();
    },
    formatDate: (date, format = "H:mm:ss MM/DD/YYYY") =>
      moment(date).utc().format(format)
  }
};
</script>
